import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { m } from 'framer-motion';
import CustomModal from '../../../Litho/Components/CustomModal';
import Buttons from '../../../Litho/Components/Button/Buttons';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';
import colors from '../../../constants/colors';

const AboutSection = () => {
	return (
		<m.section
			id='about'
			className='py-[130px] lg:py-[95px] md:py-[75px] sm:py-[50px] overflow-hidden'
			{...fadeIn}
		>
			<Container>
				<Row className='items-center'>
					<Col md={6} className='relative sm:mb-[30px]'>
						<img
							src='assets/img/services/air-freight-1.jpg'
							className='rounded-[5px] w-full'
							height='564'
							width='390'
							alt='air-freight-about'
						/>
						{/* <img src='assets/img/services/air-freight-1.jpg' /> */}
					</Col>
					<Col lg={{ span: 5, offset: 1 }} md={6}>
						<h5 className='font-serif font-medium text-darkgray w-[90%]'>
							Fast and dependable air freight solutions
						</h5>
						<p className='w-[85%] mb-[25px] lg:w-[90%]'>
							Time-critical shipments delivered worldwide. From express air
							cargo to scheduled services, we provide flexible capacity,
							proactive tracking, and customs support to keep your supply chain
							moving.
						</p>
						<div className='mt-[15px] sm:mt-0 inline-block'>
							<Buttons
								to='/contact-us'
								className='font-medium rounded-full font-serif uppercase hover:text-white bg-transparent btn-slide-right'
								size='md'
								color={colors.tprimary}
								themeColor={colors.tprimary}
								title='Get a quote'
							/>
							<Buttons
								to='/track-shipment'
								className='font-medium rounded-full font-serif uppercase hover:text-white bg-transparent btn-slide-right'
								size='md'
								color={colors.tgray}
								themeColor={colors.tgray}
								title='Track shipment'
							/>
						</div>
					</Col>
				</Row>
			</Container>
		</m.section>
	);
};

export default AboutSection;
